// @flow
import classNames from "classnames";
import React, { PureComponent } from "react";

type Props = {
  height: number,
  width: number,
  className: any
};

class Upload extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title>Ícone upload</title>
        <desc>Ícone de uma seta para cima</desc>
        <g id="icon-upload" transform="matrix(1, 0, 0, -1, 0, 15.999999999999998)">
          <path d="M 9 12.53 L 12.29 9.26 C 12.681 8.866 13.319 8.866 13.71 9.26 C 14.104 9.651 14.104 10.289 13.71 10.68 L 8.71 15.68 C 8.319 16.074 7.681 16.074 7.29 15.68 L 2.29 10.68 C 1.896 10.289 1.896 9.651 2.29 9.26 C 2.681 8.866 3.319 8.866 3.71 9.26 L 7 12.53 L 7 4.97 C 7 4.418 7.448 3.97 8 3.97 C 8.552 3.97 9 4.418 9 4.97 L 9 12.53 Z M 16 1 C 16 0.448 15.552 0 15 0 L 1 0 C 0.448 0 0 0.448 0 1 C 0 1.552 0.448 2 1 2 L 15 2 C 15.552 2 16 1.552 16 1 Z" />
        </g>
      </svg>
    );
  }
}

export default Upload;
